import { Button } from "@synthesis/shared-ui/Button";

export type EditWarningKind = "area" | "plane";

type EditRepositionWarningPopupProps = {
  kind: EditWarningKind;
  onConfirm: () => void;
  onCancel: () => void;
};

const WARNING_TEXT: Record<EditWarningKind, string> = {
  area: "Область чертежа будет изменена, потребуется корректировка позиционирования на привязанных к чертежу моделях.",
  plane: "Плоскость чертежа будет изменена, потребуется корректировка позиционирования на привязанных к чертежу моделях.",
};

const EditRepositionWarningPopup = ({ kind, onConfirm, onCancel }: EditRepositionWarningPopupProps) => (
  <div className="absolute inset-0 z-30 flex items-center justify-center" onClick={onCancel}>
    <div className="w-[400px] rounded-xl bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
      <p className="mb-4">{WARNING_TEXT[kind]}</p>
      <div className="flex items-center justify-between">
        <Button size="sm" theme="secondary" onClick={onConfirm}>
          Изменить
        </Button>
        <Button size="sm" theme="primary" onClick={onCancel}>
          Отменить
        </Button>
      </div>
    </div>
  </div>
);

export default EditRepositionWarningPopup;
